function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Form } from 'react-bootstrap';
import ChangeHighlightedImmutableUnderReviewControl from './ChangeHighlightedImmutableUnderReviewControl';
import React from 'react';
export default function ChangeHighglightedImmutableUnderReviewDropdown(_ref) {
  let {
    claim,
    object,
    valuesArray,
    valueInstanceTextFieldName = 'name',
    edittedObject,
    edittedObjectFieldName,
    userUnauthorizedToEdit,
    onChange,
    onBlur,
    refreshClaim,
    onCreate
  } = _ref;
  //backwards compatibility
  if (object) {
    claim = object;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: Form.Control,
    onChange: async e => {
      if (e.target.value !== '0') {
        await onChange(e);
      } else {
        onCreate && onCreate();
      }
    },
    onBlur: onBlur,
    disabled: claim.financials_locked || userUnauthorizedToEdit,
    name: edittedObjectFieldName,
    object: _objectSpread(_objectSpread({}, edittedObject), {}, {
      claim: _objectSpread({}, claim)
    }),
    size: "sm",
    controlAs: "select"
  }, valuesArray.map(instance => /*#__PURE__*/React.createElement("option", {
    key: instance.id,
    value: instance.value || instance.id
  }, instance[valueInstanceTextFieldName])), /*#__PURE__*/React.createElement("option", {
    key: null,
    value: null
  }), onCreate && /*#__PURE__*/React.createElement("option", {
    key: 0,
    value: 0
  }, "Add new")));
}